import * as React from 'react';
import BlogEntry from './components/blog/Entry';
import Home from './components/Home';
import NotFound from './components/NotFound';
import { Link, Router, navigate } from '@reach/router';

const redirectPathPrefix = '?redirect=';

function App() {
  React.useEffect(function () {
    const { search } = window.location;
    if (search.indexOf(redirectPathPrefix) === 0) {
      navigate(search.replace(`${redirectPathPrefix}`, ''), { replace: true });
    }
  }, []);

  return (
    <div className="wrapper">
      <header>
        <nav>
          <ul>
            <li>
              <Link to="/">
                <span>Grant R. Klinsing</span>
              </Link>
            </li>
            <li>
              <a href="http://github.com/kagd" target="_blank">
                <span>Github</span>
              </a>
            </li>
            <li>
              <a href="http://twitter.com/gklinsing" target="_blank">
                <span>Twitter</span>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/grantklinsing" target="_blank">
                <span>LinkedIn</span>
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <section className="main" id="main" role="main">
        <Router>
          <Home path="/" />
          <BlogEntry path="/articles/*" />
          <NotFound path="*" />
        </Router>
      </section>

      <footer>
        <a href="http://iracingbanner.com'"><img src="http://iracingbanner.com/banner/style2/r/rsci2/370089.png" /></a>
      </footer>
    </div>
  );
}

export default App;
